import { AccountUser } from '../account-user.model';

export class CaseAccess {
	public accountId: string;
	public caseId: string;
	public caseName: string;
	public simpleCaseId: number;
	public dateTimeCreated: string;
	public accessibleUsers: AccountUser[];
}
